import { render, staticRenderFns } from "./SuccessCertificate.vue?vue&type=template&id=86fd3206&scoped=true"
import script from "./SuccessCertificate.vue?vue&type=script&lang=js"
export * from "./SuccessCertificate.vue?vue&type=script&lang=js"
import style0 from "./SuccessCertificate.vue?vue&type=style&index=0&id=86fd3206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fd3206",
  null
  
)

export default component.exports